export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "20", value: 20 },
  { text: "50", value: 50 }
];

export const initialFilter = {
  filter: {
    name: ""
  },
  pageNumber: 1,
  pageSize: 10
};

export const SIMPZ_STATUS_ARRAY = [
  { value: "REGISTER", label: "REGISTER" },
  { value: "DATA_UPLOAD", label: "DATA UPLOAD" },
  { value: "ACTIVE", label: "ACTIVE" }
];

export const NOTIFICATION_ORGANIZATION_TYPES = {
  INFO: "INFO",
  WARNING: "WARNING",
  DANGER: "DANGER",
  PRIMARY: "PRIMARY",
  DEFAULT: "DEFAULT"
};

export const NOTIFICATION_ORGANIZATION_TYPES_ARRAY = [
  {
    name: "INFO",
    value: "INFO"
  },
  {
    name: "WARNING",
    value: "WARNING"
  },
  {
    name: "DANGER",
    value: "DANGER"
  },
  {
    name: "PRIMARY",
    value: "PRIMARY"
  },
  {
    name: "DEFAULT",
    value: "DEFAULT"
  }
];
